<script type="text/jsx">
import Icon from '../../common/UIToolKit/Icon.vue';

export default {
    functional: true,
    props: {
        icon: {
            type: String,
            default: 'warning',
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        header: {
            default: 'Nothing to see here',
            type: String,
        },
        subtext: {
            type: String,
            default: null,
        },
    },

    render(h, { props, slots, data }) {
        data.class = { 'flex items-center justify-center flex-col w-full h-full': true, ...data.class };
        return <div {...data}>
            { (props.showIcon) ? <Icon class="text-mouse h-24 w-24 mb-sm" for={props.icon}></Icon> : null }
            <h2>{ props.header }</h2>
            <p class="pb-md">{ props.subtext }</p>
            { slots().action }
        </div>;
    },
};
</script>
